import React from "react"

import { isProduction } from "@/lib/utils"

const isDisabled = true

export const TanStackRouterDevelopmentTools =
  isProduction || isDisabled
    ? (): null => null
    : React.lazy(() =>
        import("@tanstack/router-devtools").then((result) => ({
          default: result.TanStackRouterDevtools,
        })),
      )
